import { styled } from "goober";

export const DragIndicator = styled("span")`
  display: block;
  flex-shrink: 0;
  width: 32px;
  height: 2px;
  border-radius: 10px;
  background: var(--alpha16);

  &[data-orientation="horizontal"] {
    width: 2px;
    height: 32px;
  }
`;

// Handles reveal their indicator by sliding it a few pixels into place from `from` as it fades in.
export const dragIndicatorHidden = (from: string) => `
  opacity: 0;
  transform: ${from};
  transition:
    opacity var(--motion-base) var(--ease-out),
    transform var(--motion-base) var(--ease-out);
  @media (prefers-reduced-motion: reduce) {
    transform: none;
    /* !important outranks the global reduced-motion clamp, keeping a gentle fade instead of an instant cut. */
    transition: opacity var(--motion-base) var(--ease-out) !important;
  }
`;

export const dragIndicatorShown = `
  opacity: 1;
  transform: none;
`;
